import MenuIcon from '@mui/icons-material/Menu';
import { AppBar, IconButton, Toolbar } from '@mui/material';
import { styled } from '@mui/system';
import React from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { routes } from '../../common/utils/routes';
import { toggleSidebar } from '../../services/controllers/common/CommonSlice';
import OptionsHeader from './OptionsHeader';

const Header: React.FC = (): React.ReactElement => {
  const dispatch = useDispatch();

  const toggle = () => {
    dispatch(toggleSidebar());
  };

  return (
    <MainHeader position="sticky">
      <Toolbar>
        <LogoContainer>
          <IconButton sx={{ marginRight: 2 }} onClick={toggle}>
            <MenuIcon sx={{ color: 'white' }} />
          </IconButton>
          <Logo to={routes.DEFAULT}>Toàn Thắng</Logo>
        </LogoContainer>
        <OptionsHeader />
      </Toolbar>
    </MainHeader>
  );
};

const MainHeader = styled(AppBar)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  height: '64px',
  padding: '0 24px',
  '& .MuiToolbar-root': {
    width: '100%',
    margin: 'auto',
    display: 'flex',
    alignItems: 'center',
    padding: 0,
    height: '100%',
  },
}));

const Logo = styled(Link)(({ theme }) => ({
  textDecoration: 'none',
  color: '#fff',
  fontSize: 20,
  fontWeight: 600,

  '& img': {
    height: '64px',
  },

  [theme.breakpoints.down('sm')]: {
    display: 'none',
  },
}));

const LogoContainer = styled('div')({
  marginRight: 'auto',
  display: 'flex',
  alignItems: 'center',
});

export default Header;
